/* eslint-disable prefer-promise-reject-errors */

import axios from 'axios';

const instance = axios.create({
  timeout: 14000,
  // withCredentials: true
});

const apiAddress = ' https://izi-api.telekom.si/api/v2';

export default {
  loadTranslations() {
    const lang = document.documentElement.lang.toLowerCase();
    return instance.get(`/topup/data/data.${lang}.json`)
      .then((response) => response.data);
  },
  initAuth(msisdn, language) {
    if (!msisdn) {
      return Promise.reject('no MSISDN supplied');
    }
    return instance.post(`${apiAddress}/auth/init`, { MSISDN: msisdn }, {
      headers: { language },
    })
      .then((response) => response.data);
  },
  challengeResponse(msisdn, code, node) {
    if (!msisdn) {
      return Promise.reject('no MSISDN supplied');
    }
    if (!code || code.length !== 5) {
      return Promise.reject('code must be 5 chars');
    }
    return instance.post(`${apiAddress}/auth/verify`, {
      MSISDN: msisdn, challenge: code, node, checked: 'true',
    })
      .then((response) => response.data);
  },
  getVoucher(type, successRedirectUrl, failureRedirectUrl, token, language) {
    if (!token || !type || !successRedirectUrl || !failureRedirectUrl) {
      return Promise.reject('missing parameter');
    }
    return instance.post(`${apiAddress}/voucher`, {
      type,
      returnSuccess: successRedirectUrl,
      returnFailed: failureRedirectUrl,
    }, { headers: { Authorization: `Bearer ${token}`, language } })
      .then((response) => response.data);
  },
  getFinalVoucher(id, token) {
    return instance.get(`${apiAddress}/voucher/${id}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        if (response.data.status === true) {
          return response.data;// we redirect to here.
        }
        return false;
      });
  },
};



// WEBPACK FOOTER //
// ./src/apiAccess.js